import React from "react";
import { Link } from "react-router-dom";
import ProductsCard from "../cards/ProductsCard";

// Data \\
import product_data from "../../assets/data/products.json";
import ChickenCard from "../cards/ChickenCard";

const Chicke = () => {
  const startIndex = 0;
  const endIndex = 6;
  const newData = product_data.slice(startIndex, endIndex);
  return (
    <div>
      <div className="newProduct">
        <div className="newProduct_items">
          <div className="newProduct_items_title mb-[60px]">
            <div className="text">
              <p>Best furniture for Chicken</p>
            </div>
            <div className="title mt-5">
              <div className="sort flex justify-between">
                <h3>Chicken </h3>
                <span className="flex items-center gap-5">
                  <p>Filter</p>
                  <select className=" rounded-2xl" name="prices" id="prices">
                    <option value="price" selected>
                      Price ascending
                    </option>
                    <option value="cheap">cheap</option>
                    <option value="expensive">Expensive</option>
                  </select>
                </span>
              </div>
            </div>
          </div>

          <div className="newProduct_items_cardBox flex flex-wrap justify-around ">
            {newData.map((data, index) => (
              <ChickenCard key={data.id} data={data} />
            ))}
          </div>

          <div className="seeMoreNew">
            {/* <Link to={"/menall"} className="newProduct_link">
              Показать Больше
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chicke;
